module.exports = __webpack_public_path__ + "img/waterfall-mask-image-en.a80fc9d.png";